import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Star } from "lucide-react";

const STATUSES = ["pending", "approved", "rejected"];

export default function AdminReviews() {
  const [reviews, setReviews] = useState([]);
  const [filter, setFilter] = useState("pending");

  const load = async () => {
    const { data } = await api.get(`/admin/reviews${filter ? `?status=${filter}` : ""}`);
    setReviews(data);
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [filter]);

  const setStatus = async (id, status) => {
    try { await api.put(`/admin/reviews/${id}/status`, { status }); toast.success("Updated."); load(); }
    catch { toast.error("Failed."); }
  };
  const del = async (id) => {
    if (!confirm("Delete this review?")) return;
    await api.delete(`/admin/reviews/${id}`);
    load();
  };

  return (
    <div data-testid="admin-reviews">
      <div className="flex items-baseline justify-between mb-8">
        <div>
          <p className="text-[11px] uppercase tracking-nav text-[#5C1A1B]">Moderation</p>
          <h1 className="font-serif text-4xl">Reviews</h1>
        </div>
        <select value={filter} onChange={(e) => setFilter(e.target.value)} className="border border-black/10 px-3 py-2 text-sm" data-testid="admin-rev-filter">
          <option value="">All</option>
          {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
        </select>
      </div>

      <div className="space-y-4">
        {reviews.length === 0 && <p className="text-sm text-[#7A7A7A]">No reviews.</p>}
        {reviews.map((r) => (
          <div key={r.review_id} className="bg-white border border-black/5 p-5" data-testid={`admin-rev-${r.review_id}`}>
            <div className="flex flex-wrap items-baseline justify-between gap-3">
              <div className="flex items-center gap-3">
                <div className="flex gap-0.5">
                  {[1,2,3,4,5].map((n) => (
                    <Star key={n} size={14} strokeWidth={1.2}
                      className={n <= r.rating ? "text-[#BCA37F]" : "text-[#BCA37F]/30"}
                      fill={n <= r.rating ? "#BCA37F" : "none"} />
                  ))}
                </div>
                <p className="font-serif text-lg">{r.title || "Review"}</p>
                <span className={`text-[10px] uppercase tracking-nav px-2 py-0.5 ${r.status === "approved" ? "bg-[#388E3C] text-white" : r.status === "rejected" ? "bg-[#D32F2F] text-white" : "bg-[#BCA37F]/30 text-[#1A1A1A]"}`}>{r.status}</span>
              </div>
              <div className="flex items-center gap-3">
                <select value={r.status} onChange={(e) => setStatus(r.review_id, e.target.value)} className="border border-black/10 px-2 py-1 text-sm" data-testid={`admin-rev-status-${r.review_id}`}>
                  {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
                </select>
                <button onClick={() => del(r.review_id)} className="text-[11px] uppercase tracking-nav text-[#D32F2F]" data-testid={`admin-rev-del-${r.review_id}`}>Delete</button>
              </div>
            </div>
            <p className="text-[11px] uppercase tracking-nav text-[#7A7A7A] mt-2">
              {r.author_name} {r.author_email && `· ${r.author_email}`} · {r.created_at?.slice(0, 10)}
              {r.product?.name && ` · on “${r.product.name}”`}
            </p>
            <p className="mt-3 text-sm text-[#1A1A1A] leading-relaxed">{r.body}</p>
            {r.photos?.length > 0 && (
              <div className="mt-3 flex gap-2">
                {r.photos.map((p, i) => <img key={i} src={p} alt="" className="w-20 h-24 object-cover" />)}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
